import { useEffect, type ReactElement } from 'react'
import {
	type ErrorResponse,
	isRouteErrorResponse,
	Link,
	useParams,
	useRouteError,
} from 'react-router'

import { getErrorMessage } from '#app/utils/misc'

type StatusHandler = (info: {
	error: ErrorResponse
	params: Record<string, string | undefined>
}) => ReactElement | null

export function GeneralErrorBoundary({
	defaultStatusHandler = ({ error }) => (
		<div className="flex flex-col items-center gap-4">
			<Link to="/" className="btn btn-ghost">
				Back to home
			</Link>
			<p>
				{error.status} {error.data}
			</p>
		</div>
	),
	statusHandlers,
	unexpectedErrorHandler = (error) => <p>{getErrorMessage(error)}</p>,
}: {
	defaultStatusHandler?: StatusHandler
	statusHandlers?: Record<number, StatusHandler>
	unexpectedErrorHandler?: (error: unknown) => ReactElement | null
}) {
	const error = useRouteError()
	const params = useParams()
	const isResponse = isRouteErrorResponse(error)

	if (typeof document !== 'undefined') {
		console.error(error)
	}

	useEffect(() => {
		if (isResponse) return
		// TODO this where we can log errors to monitoring tools
		// captureException(error);
	}, [error, isResponse])

	return (
		<div
			data-theme="exzeo"
			className="theme-exzeo container flex shrink grow items-center justify-center p-20 text-base-content"
		>
			{isResponse
				? (statusHandlers?.[error.status] ?? defaultStatusHandler)({
						error,
						params,
					})
				: unexpectedErrorHandler(error)}
		</div>
	)
}
